<app-header></app-header>
<div class="wrapper">
  <app-banner></app-banner>
  @if (products$ | async; as products) { @if (products['paired'].length === 0) {
  <div class="unlinked-card">
    <mat-icon>link_off</mat-icon>
    <h6>{{ 'home.noAccount' | translate }}</h6>
    <p>{{ 'home.chooseProduct' | translate: { actabl: 'Actabl' } }}</p>
  </div>
  } @if (products['paired'].length > 0) {
  <app-product-section
    [isPaired]="true"
    [products]="products['paired']"
  ></app-product-section>
  } @if (products['paired'].length > 0 && products['unpaired'].length > 0) {
  <hr />
  } @if (products['unpaired'].length > 0) {
  <app-product-section
    [isPaired]="false"
    [products]="products['unpaired']"
  ></app-product-section>
  } }
</div>
